import { useState, useEffect, useCallback } from 'react';
import organizationService, { FoSyncHistoryItem } from '@/services/api/organizationService';

interface UseSyncHistoryOptions {
  limit?: number;
  entity_type?: string;
}

export function useSyncHistory(options?: UseSyncHistoryOptions) {
  const [history, setHistory] = useState<FoSyncHistoryItem[]>([]);
  const [loading, setLoading] = useState(true);

  const limit = options?.limit ?? 10;
  const entity_type = options?.entity_type;

  const fetchHistory = useCallback(async () => {
    try {
      setLoading(true);
      const data = await organizationService.getSyncHistory({ limit, entity_type });
      setHistory(data.history);
    } catch (err) {
      console.error('Failed to fetch sync history:', err);
    } finally {
      setLoading(false);
    }
  }, [limit, entity_type]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  // Most recent completed or partial sync
  const lastSync = history.find(h => h.status === 'completed' || h.status === 'partial') ?? null;

  return { history, loading, lastSync, refetch: fetchHistory };
}
